/* Landing folivia — JS extraido de Clon Vionera - Pumpkin Seed Oil/index.html.
   Cargado por layout/landing.liquid (case 'folivia'). */

// Galería: thumbs → main
document.querySelectorAll('#thumbs .xs-thumb').forEach(t=>{
  t.addEventListener('click',()=>{
    document.querySelectorAll('#thumbs .xs-thumb').forEach(x=>x.classList.remove('activo'));
    t.classList.add('activo');
    const main=document.querySelector('#galeriaMain img');
    if(main){main.style.display='';main.src=t.dataset.src;}
  });
});
// Bundles: selección
document.querySelectorAll('#bundles .xs-bundle').forEach(b=>{
  b.addEventListener('click',()=>{
    document.querySelectorAll('#bundles .xs-bundle').forEach(x=>x.classList.remove('activo'));
    b.classList.add('activo');
  });
});
// Before/After carrusel
let baIdx=0;
const baSlides=document.querySelectorAll('.xs-ba-slide');
const baDots=document.querySelectorAll('#baDots button');
function baIr(i){
  baIdx=(i+baSlides.length)%baSlides.length;
  baSlides.forEach((s,j)=>s.classList.toggle('activo',j===baIdx));
  baDots.forEach((d,j)=>d.classList.toggle('activo',j===baIdx));
}
function baMover(d){baIr(baIdx+d)}
// Fórmula carrusel
let ingIdx=0;
const ingSlides=document.querySelectorAll('.ing-slide');
const ingPills=document.querySelectorAll('.xs-pills .xs-pill');
function ingIr(i){
  ingIdx=(i+ingSlides.length)%ingSlides.length;
  ingSlides.forEach((s,j)=>s.style.display=j===ingIdx?'':'none');
  ingPills.forEach((p,j)=>p.classList.toggle('activo',j===ingIdx));
}
function ingMover(d){ingIr(ingIdx+d)}
// Estrellas del modal
let pickV=5;
document.querySelectorAll('#pickEstrellas span').forEach(s=>{
  s.addEventListener('click',()=>{
    pickV=+s.dataset.v;
    document.querySelectorAll('#pickEstrellas span').forEach(x=>x.classList.toggle('on',+x.dataset.v<=pickV));
  });
});
document.querySelectorAll('#pickEstrellas span').forEach(x=>x.classList.add('on'));
// Enviar reseña (front-only)
function enviarResena(){
  const n=document.getElementById('resenaNombre').value.trim()||'Cliente';
  const t=document.getElementById('resenaTexto').value.trim();
  if(!t){alert('Escribe tu reseña');return}
  const div=document.createElement('div');
  div.className='xs-review';
  div.innerHTML='<div class="estrellas">'+'★'.repeat(pickV)+'☆'.repeat(5-pickV)+'</div><div class="quien"><span class="avatar">👤</span><span class="nombre"></span></div><p></p>';
  div.querySelector('.nombre').textContent=n;
  div.querySelector('p').textContent=t;
  const lista=document.getElementById('listaReviews');
  lista.insertBefore(div,lista.firstChild);
  document.getElementById('modalResena').classList.remove('abierto');
  document.getElementById('resenaNombre').value='';document.getElementById('resenaTexto').value='';
}
// Sticky bar: ocultar cuando el hero está visible
const sticky=document.getElementById('stickyBar');
const hero=document.querySelector('.xs-hero');
if('IntersectionObserver' in window){
  new IntersectionObserver(e=>{
    sticky.style.display=e[0].isIntersecting?'none':'flex';
  },{threshold:.15}).observe(hero);
}


/* ============================================================
   Seleccion de bundle + trigger Releasit COD  (folivia)
   Patron canonico (memory/project_bundles_as_variants):
   cada bundle = 1 variante real con precio POR UNIDAD; se manda la cantidad
   real en input[name="quantity"] (Releasit lo lee del DOM al disparar COD),
   asi precio_unitario x qty = total del bundle y el pedido lleva las unidades
   fisicas reales para Dropi.
   NO usar _rsiV2.setState como primer path: solo el click nativo del boton
   Releasit re-lee window.productData tras cambiar la variante.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  var selectedVariantId = null;
  var selectedQty = 1;

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) {
      i.value = variantId;
    });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function bundleQty(el) {
    var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
    if (!q) {
      var idx = parseInt(el.getAttribute('data-bundle-index'), 10);
      q = isNaN(idx) ? 1 : idx + 1;
    }
    return q || 1;
  }

  // Los tiers llevan variant-id + qty; los CTA solo llaman a TriggerCOD(this),
  // asi el selector sirve igual si el tier es <div> o <button>.
  var bundles = document.querySelectorAll('[data-bundle-variant-id][data-bundle-qty]');

  function selectBundle(el) {
    var id = el.getAttribute('data-bundle-variant-id');
    if (!id) return;
    selectedVariantId = id;
    selectedQty = bundleQty(el);
    setVariantOnAllForms(id, selectedQty);
  }

  bundles.forEach(function (el) {
    el.addEventListener('click', function () { selectBundle(el); });
  });

  // Init: el bundle marcado activo en el HTML (o el primero)
  (function initSelected() {
    var active = null;
    for (var i = 0; i < bundles.length; i++) {
      var c = bundles[i].className || '';
      if (/(^|\s)(act|sel|activo|on|selected)(\s|$)/.test(c)) { active = bundles[i]; break; }
    }
    if (!active) active = bundles[0];
    if (!active) return;
    selectedVariantId = active.getAttribute('data-bundle-variant-id');
    selectedQty = bundleQty(active);
    setVariantOnAllForms(selectedVariantId, selectedQty);
  })();

  window.foliviaTriggerCOD = function (btn) {
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || selectedQty;
    if (variantId) setVariantOnAllForms(variantId, qty);
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
